module.exports = __webpack_public_path__ + "static/LJ-59cd099cfd5d63a9fb11b52b6fed80bc.webm";